module.exports = __webpack_public_path__ + "static/media/Trending5.24ebbd90.png";